import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackspace } from '@fortawesome/free-solid-svg-icons';

const NumericKeypad = (props) => {
    const appendDigit = (digit) => {
        props.onChange((props.value || '')+digit)
    }

    const appendComma = () => {
        if(!props.allowDecimal || (props.value || '').includes(',')) return
        props.onChange((props.value || '')+',')
    }

    const backspace = () => {
        props.onChange((props.value || '').slice(0,-1))
    }

    return (
        <div className="numericKeypad mb-3">
            <div className="row mb-1">
                {[1,2,3].map(d => (
                    <div className="col-4" key={d}>
                        <button type="button" className="btn btn-outline-secondary btn-lg w-100" onClick={()=>appendDigit(d)}>{d}</button>
                    </div>
                ))}
            </div>
            <div className="row mb-1">
                {[4,5,6].map(d => (
                    <div className="col-4" key={d}>
                        <button type="button" className="btn btn-outline-secondary btn-lg w-100" onClick={()=>appendDigit(d)}>{d}</button>
                    </div>
                ))}
            </div>
            <div className="row mb-1">
                {[7,8,9].map(d => (
                    <div className="col-4" key={d}>
                        <button type="button" className="btn btn-outline-secondary btn-lg w-100" onClick={()=>appendDigit(d)}>{d}</button>
                    </div>
                ))}
            </div>
            <div className="row">
                <div className="col-4">
                    <button type="button" className="btn btn-outline-secondary btn-lg w-100" disabled={!props.allowDecimal || (props.value || '').includes(',')} onClick={appendComma}>,</button>
                </div>
                <div className="col-4">
                    <button type="button" className="btn btn-outline-secondary btn-lg w-100" onClick={()=>appendDigit(0)}>0</button>
                </div>
                <div className="col-4">
                    <button type="button" className="btn btn-outline-secondary btn-lg w-100" onClick={backspace}>
                        <FontAwesomeIcon icon={faBackspace} />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default NumericKeypad;
